/**
 * 防复制脚本：禁用右键菜单、键盘快捷复制与图片拖拽
 * - 设计模式下不启用，避免影响主题编辑器
 * - 表单与可编辑区域不拦截，保证正常输入与复制
 */
(function () {
  try {
    // 设计模式下退出
    if (document.documentElement.classList.contains('shopify-design-mode')) {
      return;
    }

    // 应用全局不可选择样式
    document.documentElement.classList.add('no-select');

    /**
     * 判断当前元素是否允许交互（输入、编辑等）
     */
    function isEditable(target) {
      if (!target) return false;
      return (
        target.closest('input, textarea, [contenteditable="true"], .CodeMirror, .ace_editor') !== null
      );
    }

    /**
     * 禁用右键菜单（排除可编辑区域）
     */
    document.addEventListener('contextmenu', function (e) {
      if (isEditable(e.target)) return;
      console.debug('[AntiCopy] Block contextmenu');
      e.preventDefault();
    }, { capture: true });

    /**
     * 禁用图片拖拽与右键
     */
    Array.prototype.forEach.call(document.querySelectorAll('img'), function (img) {
      img.setAttribute('draggable', 'false');
      img.addEventListener('contextmenu', function (e) { e.preventDefault(); }, { capture: true });
      img.addEventListener('dragstart', function (e) { e.preventDefault(); }, { capture: true });
    });

    /**
     * 禁用常见快捷键：复制(C)、保存(S)、打印(P)、查看源(U)、开发者工具(I/F12)
     * - Mac 使用 metaKey，Windows 使用 ctrlKey
     */
    document.addEventListener('keydown', function (e) {
      if (isEditable(e.target)) return;

      var key = e.key.toLowerCase();
      var withCtrl = e.ctrlKey || e.metaKey;

      // 阻止复制、保存、打印、查看源代码
      if (withCtrl && (key === 'c' || key === 's' || key === 'p' || key === 'u')) {
        console.warn('[AntiCopy] Block shortcut', key);
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      // 阻止开发者工具（部分浏览器可能不生效）
      if ((withCtrl && e.shiftKey && key === 'i') || key === 'f12') {
        console.warn('[AntiCopy] Block devtools');
        e.preventDefault();
        e.stopPropagation();
        return;
      }
    }, { capture: true });

    /**
     * 禁用拖拽（非可编辑区域）
     */
    document.addEventListener('dragstart', function (e) {
      if (isEditable(e.target)) return;
      e.preventDefault();
    }, { capture: true });

  } catch (err) {
    console.error('[AntiCopy] Init error', err);
  }
})();

